enum AreaAtuacao {
    Animal = 0,
    Humana = 1
}

export default AreaAtuacao;